import { RichEditorTemplate } from '@ametista-ai/editor/types';
import { parseContentToDoc } from '@ametista-ai/editor/utils';
import { useEditorEventCallback } from '@handlewithcare/react-prosemirror';
import * as Sentry from '@sentry/react';
import { Button, Group, Menu } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Icon } from '@/ui';

export function TemplateMenu({ templates }: { templates: RichEditorTemplate[] }) {
  const [opened, { toggle, close }] = useDisclosure(false);

  const handleInsertTemplate = useEditorEventCallback((view, template: RichEditorTemplate) => {
    const schema = view.state.schema;
    try {
      const templateDoc = parseContentToDoc(template.content, schema);

      view.dispatch(view.state.tr.insert(view.state.doc.content.size, templateDoc));
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          templateId: template.id,
          content: template.content,
        },
      });
    }
  });

  return (
    <Menu opened={opened} onClose={close}>
      <Menu.Target>
        <Button size="xs" variant="default" onClick={toggle}>
          <Group gap="xs">
            <Icon name="template" />
            {opened ? <Icon name="chevronUp" /> : <Icon name="chevronDown" />}
          </Group>
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {templates.map((template) => (
          <Menu.Item key={template.id} onClick={() => handleInsertTemplate(template)}>
            {template.name}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
